// .u_amo-select
class UAMOSelect extends Uneet {
  constructor (domElement, changeCallback) {
    super(domElement)
    this.changeCallback = (changeCallback !== null) ? changeCallback : this.__noop
    this.$select = null
    this.__init()
  }

  __init () {
    this.$select = jQuery(this._e.querySelectorAll('select')[0])
    this.$select.select2({
      allowClear: true,
      placeholder: {
        id: '-1',
        text: this.placeholder
      },
      dropdownParent: jQuery(this._e)
    })
    this.$select.on('change', (e) => {
      console.log(e)
      this.onChange(e)
    })
  }

  getVariableName () {
    return this.varname
  }

  onChange (e) {
    if (typeof this.changeCallback === 'function') {
      this.changeCallback(e)
    }
  }

  getURLEncodedValue () {
    return encodeURIComponent(JSON.stringify(this.$select.select2('val')))
  }

  clear () {
    const val = this.$select.select2('val')
    if (val.length !== 0) {
      this.$select.select2().val(null).trigger('change', 'caca')
    }
  }
}
